import { useCallback } from 'react';

import { useConditionState } from './useConditionState';

export const useFieldState = () => {
  const {
    condition: { field },
    setCondition,
  } = useConditionState();
  const setField = useCallback(
    (newField?: string) => setCondition((condition) => ({ ...condition, field: newField })),
    [setCondition],
  );
  return { field, setField };
};
